import { SxProps } from '@mui/material'
import StylesShoppingCartActionsServiceInterface
  from '~/src/components/cart/shopping-cart-actions/styles/StylesShoppingCartActionsServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class StylesShoppingCartActionsServiceStyleTwo extends TemplateServiceStyleBase implements StylesShoppingCartActionsServiceInterface {
  public getContainerSxProps(): SxProps {
    return {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      [this.muiTheme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        '> a': {
          width: '100%',
          '> button': {
            width: 'inherit'
          }
        }
      }
    }
  }

  public getLoginAndGoToCheckoutSxProps(): SxProps {
    return {
      width: 'inherit'
    }
  }

  public getGoToCheckoutSxProps(): SxProps {
    return {
      width: 'inherit'
    }
  }

  public getContinueAsGuestSxProps(): SxProps {
    return {
      color: 'text.black'
    }
  }
}
